import { Injectable } from '@angular/core';
//import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

//const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
//const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

  constructor() {
  //console.log('excelservice servicio lo carga')
}

  // test(){
  //   console.log('entro')
  // }

  public exportAsExcelFile(tbl, excelFileName: string): void {

    //const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    //const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    //this.saveAsExcelFile(excelBuffer, excelFileName);
    //const wb: XLSX.WorkBook = XLSX.utils.book_new();
    //XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    var wb = XLSX.utils.table_to_book(tbl);
    XLSX.writeFile(wb, excelFileName + '.xlsx');
  }

  /*private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }*/

}



// WEBPACK FOOTER //
// ./src/app/excel.service.ts